import { render, staticRenderFns } from "./orderDetail.vue?vue&type=template&id=fd5dc71e&scoped=true"
import script from "./orderDetail.vue?vue&type=script&lang=ts"
export * from "./orderDetail.vue?vue&type=script&lang=ts"
import style0 from "./orderDetail.vue?vue&type=style&index=0&id=fd5dc71e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd5dc71e",
  null
  
)

export default component.exports